import * as types from './mutation-types';
import { API } from '../api';

export default {
    submitImport({ commit }, importParams) {
        commit(types.IMPORT_SUBMIT_IMPORT, importParams);
    },
    initBasicData({ dispatch, state }) {
        if(!state.gotUserTypeData) {
            API.getUserType({}, function(data){
                console.log('初始化命局基础数据::::::::', data, state.gotUserTypeData)
                state.gotUserTypeData = true;
                dispatch('base/initSituationData', data.situation)
                dispatch('base/initStrongData', data.strong)
                dispatch('base/initMedicineData', data.medicine)
                dispatch('group/initGroupListData', data.group)

                dispatch('setting/initSettingData')
            })
        }
    }
}